import React from 'react';
import { X, Plus, Minus, Trash2, Send, ShoppingBag } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const CartDrawer = () => {
  const { cart, drawerOpen, setDrawerOpen, updateQty, removeFromCart, clearCart } = useCart();

  return (
    <>
      <div
        className={`fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[60] transition-opacity ${drawerOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={() => setDrawerOpen(false)}
      />
      <aside className={`fixed top-0 right-0 h-full w-full sm:w-[420px] bg-white shadow-2xl z-[70] transform transition-transform duration-300 flex flex-col ${drawerOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between p-5 border-b border-blue-100">
          <h3 className="font-bold text-slate-900 text-lg flex items-center gap-2">
            <ShoppingBag className="w-5 h-5 text-blue-600" /> Twój koszyk
          </h3>
          <button onClick={() => setDrawerOpen(false)} className="p-2 hover:bg-blue-50 rounded-full" aria-label="Close">
            <X className="w-5 h-5 text-slate-600" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5">
          {cart.length === 0 ? (
            <div className="text-center py-16">
              <div className="w-20 h-20 rounded-full bg-blue-50 mx-auto flex items-center justify-center mb-4">
                <ShoppingBag className="w-8 h-8 text-blue-300" />
              </div>
              <p className="text-slate-500 mb-5">Twój koszyk jest pusty</p>
              <Link to="/sklep" onClick={() => setDrawerOpen(false)} className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-full font-semibold text-sm transition">
                Wróć do sklepu
              </Link>
            </div>
          ) : (
            <div className="space-y-3">
              {cart.map(item => (
                <div key={item.id} className="flex gap-3 p-3 rounded-xl border border-blue-50 hover:border-blue-200 transition">
                  <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-blue-50 to-sky-50 flex-shrink-0 overflow-hidden flex items-center justify-center">
                    {item.image ? (
                      <img src={item.image} alt={item.name} className="w-full h-full object-contain p-1" />
                    ) : (
                      <div className="w-8 h-10 rounded" style={{ backgroundColor: item.color }} />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-slate-900 text-sm truncate">{item.name}</div>
                    <div className="text-xs text-slate-500">{item.dosage}</div>
                    <div className="flex items-center mt-2">
                      <div className="flex items-center border border-blue-100 rounded-full">
                        <button onClick={() => updateQty(item.id, item.qty - 1)} className="w-7 h-7 flex items-center justify-center text-blue-600 hover:bg-blue-50 rounded-full"><Minus className="w-3 h-3" /></button>
                        <span className="px-2 text-sm font-semibold">{item.qty}</span>
                        <button onClick={() => updateQty(item.id, item.qty + 1)} className="w-7 h-7 flex items-center justify-center text-blue-600 hover:bg-blue-50 rounded-full"><Plus className="w-3 h-3" /></button>
                      </div>
                    </div>
                  </div>
                  <button onClick={() => removeFromCart(item.id)} className="text-slate-400 hover:text-red-500 self-start p-1"><Trash2 className="w-4 h-4" /></button>
                </div>
              ))}
              <button onClick={clearCart} className="text-xs text-slate-500 hover:text-red-500 mt-2">Wyczyść koszyk</button>
            </div>
          )}
        </div>

        {cart.length > 0 && (
          <div className="border-t border-blue-100 p-5 bg-blue-50/40">
            <p className="text-sm text-slate-600 mb-4 text-center">
              Skontaktuj się przez Telegram, aby otrzymać wycenę i sfinalizować zamówienie.
            </p>
            <a href="https://t.me/+9A5CpRihCfNjMzc0" target="_blank" rel="noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-3.5 rounded-full font-semibold transition shadow-lg shadow-blue-200">
              <Send className="w-4 h-4" /> Sfinalizuj przez Telegram
            </a>
            <p className="text-xs text-slate-500 text-center mt-3">100% anonimowo - bez pozostawiania danych</p>
          </div>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
